import(/* webpackMode: "eager", webpackExports: ["CertificationInterestForm"] */ "/vercel/path0/components/certification-interest-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SuggestUnknownCertification"] */ "/vercel/path0/components/suggest-unknown-certification.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
